import React from 'react';
import './Mensageria.css';
import usePageMeta from '../../hooks/usePageMeta';

const Mensageria: React.FC = () => {
  usePageMeta({
    title: 'Chatbot e Multiatendimento para WhatsApp',
    description:
      'Solução completa de chatbot e multiatendimento para WhatsApp: automatize conversas, capte leads e aumente suas vendas com a plataforma de mensageria da UpdateCommit.',
    path: '/solucoes/mensageria',
  });

  const openWhatsApp = (message: string) => {
    const encodedMessage = encodeURIComponent(message);
    window.open(
      `https://wa.me/5521936185311?text=${encodedMessage}`,
      '_blank',
      'noopener,noreferrer'
    );
  };

  return (
    <div className="mensageria-page">
      {/* Hero Section */}
      <section className="hero-mensageria">
        <div className="container-mensageria">
          <div className="hero-grid">
            <div className="hero-text">
              <h1>Revolucione seu atendimento com nosso chatbot para WhatsApp!</h1>
              <p>
                O AtendeChat é uma solução completa de chatbot e multiatendimento para WhatsApp, 
                ideal para automatizar conversas, captar leads e aumentar suas vendas.
              </p>
              <div className="hero-buttons">
                <button
                  className="btn-primary-large"
                  onClick={() => openWhatsApp('Olá! Quero começar a usar a solução de mensageria da UpdateCommit.')}
                >
                  Começar Agora
                </button>
                <button
                  className="btn-secondary-large"
                  onClick={() => openWhatsApp('Olá! Gostaria de agendar uma demonstração da solução de mensageria.')}
                >
                  Agendar Demo
                </button>
              </div>
            </div>
            <div className="hero-mockup">
              <div className="laptop-mockup">
                <div className="laptop-screen">
                  <div className="whatsapp-preview">
                    <div className="chat-header-ws">
                      <div className="user-info">
                        <div className="avatar-ws"></div>
                        <span>Cliente</span>
                      </div>
                    </div>
                    <div className="chat-messages">
                      <div className="message received">
                        <p>Olá! Gostaria de saber mais sobre os produtos</p>
                      </div>
                      <div className="message sent">
                        <p>Olá! Claro, será um prazer ajudar. Temos várias opções disponíveis...</p>
                      </div>
                      <div className="message received">
                        <p>Perfeito! Quais são os preços?</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="whatsapp-icons">
                <div className="icon-float icon-1">
                  <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
                    <circle cx="30" cy="30" r="28" fill="white"/>
                    <path d="M30 10C18.954 10 10 18.954 10 30c0 3.5 0.9 6.8 2.5 9.7L10 50l10.8-2.8c2.7 1.5 5.8 2.3 9.2 2.3 11.046 0 20-8.954 20-20S41.046 10 30 10z" fill="#25D366"/>
                    <path d="M40.7 38.5c-.4 1.1-2.3 2.1-3.2 2.2-.9.1-.9.6-5.9-1.3-5-1.9-8.2-7-8.4-7.3-.2-.3-1.7-2.3-1.7-4.4s1.1-3.1 1.5-3.5c.4-.4.8-.5 1.1-.5s.6 0 .9.01c.3.01.6 0 .9.65.3.65 1.1 2.6 1.2 2.8.1.2.2.4.1.65-.1.25-.2.4-.4.6-.2.2-.4.45-.6.65-.2.2-.4.4-.2.8.2.4.9 1.5 1.9 2.4 1.4 1.2 2.5 1.6 2.9 1.8.4.2.6.2.8-.1.2-.3.9-1 1.2-1.4.3-.4.6-.3.9-.2.3.1 2 .9 2.3 1.1.3.2.5.3.6.4.1.1.1.6-.3 1.7z" fill="white"/>
                  </svg>
                </div>
                <div className="icon-float icon-2">
                  <svg width="50" height="50" viewBox="0 0 50 50" fill="none">
                    <circle cx="25" cy="25" r="23" fill="white"/>
                    <path d="M25 8C16.7 8 10 14.7 10 23c0 2.6 0.7 5 2 7.2L10 40l10.2-2.7c2 1.1 4.3 1.7 6.8 1.7 8.3 0 15-6.7 15-15S33.3 8 25 8z" fill="#25D366"/>
                  </svg>
                </div>
                <div className="icon-float icon-3">
                  <svg width="45" height="45" viewBox="0 0 45 45" fill="none">
                    <circle cx="22.5" cy="22.5" r="21" fill="white"/>
                    <circle cx="22.5" cy="22.5" r="18" fill="#25D366"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Recursos Poderosos */}
      <section className="recursos-poderosos reveal">
        <div className="container-mensageria">
          <div className="section-header-msg">
            <h2>Recursos poderosos para sua equipe</h2>
            <p>Ferramentas intuitivas que transformam a maneira como você gerencia projetos e equipes.</p>
          </div>

          <div className="recursos-grid">
            <div className="recurso-card">
              <div className="recurso-icon">📋</div>
              <h3>Gestão de Tarefas</h3>
              <p>Atribua e gerencie tarefas para sua equipe de atendimento.</p>
            </div>

            <div className="recurso-card">
              <div className="recurso-icon">👥</div>
              <h3>Contatos</h3>
              <p>Centralize todos os seus contatos em um único lugar.</p>
            </div>

            <div className="recurso-card">
              <div className="recurso-icon">📅</div>
              <h3>Agendamentos</h3>
              <p>Programe e dispare mensagens diretamente pelo WhatsApp.</p>
            </div>

            <div className="recurso-card">
              <div className="recurso-icon">🏷️</div>
              <h3>Tags</h3>
              <p>Categorize e segmente seus contatos para um atendimento mais personalizado.</p>
            </div>

            <div className="recurso-card">
              <div className="recurso-icon">💬</div>
              <h3>Chat Interno</h3>
              <p>Facilite a comunicação interna da sua equipe.</p>
            </div>

            <div className="recurso-card">
              <div className="recurso-icon">🔗</div>
              <h3>Integrações</h3>
              <p>Conecte-se com Typebot, n8n, Dialogflow, Webhook e ChatGPT.</p>
            </div>

            <div className="recurso-card">
              <div className="recurso-icon">📱</div>
              <h3>Conexões QR Code</h3>
              <p>Conecte facilmente ao WhatsApp através do QR Code.</p>
            </div>

            <div className="recurso-card">
              <div className="recurso-icon">🤖</div>
              <h3>Chatbots</h3>
              <p>Automatize respostas do WhatsApp com estrutura, flow builder e ChatGPT.</p>
            </div>

            <div className="recurso-card">
              <div className="recurso-icon">⚡</div>
              <h3>Respostas Rápidas</h3>
              <p>Responda rapidamente com mensagens pré-configuradas.</p>
            </div>

            <div className="recurso-card">
              <div className="recurso-icon">👨‍💼</div>
              <h3>Multiusuários</h3>
              <p>Permita que vários usuários da sua equipe utilizem o sistema simultaneamente.</p>
            </div>

            <div className="recurso-card">
              <div className="recurso-icon">📊</div>
              <h3>CRM Kanban</h3>
              <p>Organize seus contatos e leads em um sistema Kanban intuitivo.</p>
            </div>

            <div className="recurso-card">
              <div className="recurso-icon">🎯</div>
              <h3>Multiatendimento</h3>
              <p>Gerencie vários atendimentos simultaneamente, aumentando a eficiência do seu time.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Planos */}
      <section className="planos-section-msg reveal">
        <div className="container-mensageria">
          <div className="section-header-msg">
            <h2>Escolha o plano ideal para seu negócio</h2>
            <p>Planos flexíveis que crescem com sua empresa</p>
          </div>

          <div className="planos-grid-msg">
            {/* Starter */}
            <div className="plano-card-msg">
              <h3>Starter</h3>
              <p className="plano-subtitle">Perfeito para pequenas equipes e startups</p>
              <div className="plano-preco">
                <span className="preco">R$ 49</span>
                <span className="periodo">/mês</span>
              </div>
              <ul className="plano-features">
                <li>Até 5 membros</li>
                <li>5GB de armazenamento</li>
                <li>3 projetos ativos</li>
                <li>Suporte por email</li>
              </ul>
              <button
                className="btn-plano-msg"
                onClick={() => openWhatsApp('Olá! Tenho interesse no plano Starter da solução de mensageria.')}
              >
                Começar Agora
              </button>
            </div>

            {/* Professional */}
            <div className="plano-card-msg featured">
              <div className="badge-popular-msg">Mais Popular</div>
              <h3>Professional</h3>
              <p className="plano-subtitle">Ideal para empresas em crescimento</p>
              <div className="plano-preco">
                <span className="preco">R$ 99</span>
                <span className="periodo">/mês</span>
              </div>
              <ul className="plano-features">
                <li>Até 20 membros</li>
                <li>25GB de armazenamento</li>
                <li>Projetos ilimitados</li>
                <li>Suporte prioritário</li>
                <li>API de integração</li>
              </ul>
              <button
                className="btn-plano-msg"
                onClick={() => openWhatsApp('Olá! Tenho interesse no plano Professional da solução de mensageria.')}
              >
                Começar Agora
              </button>
            </div>

            {/* Enterprise */}
            <div className="plano-card-msg">
              <h3>Enterprise</h3>
              <p className="plano-subtitle">Para grandes empresas e corporações</p>
              <div className="plano-preco">
                <span className="preco">R$ 249</span>
                <span className="periodo">/mês</span>
              </div>
              <ul className="plano-features">
                <li>Usuários ilimitados</li>
                <li>100GB de armazenamento</li>
                <li>Projetos ilimitados</li>
                <li>Suporte 24/7 dedicado</li>
                <li>API avançada e integrações</li>
                <li>Customização completa</li>
              </ul>
              <button
                className="btn-plano-msg"
                onClick={() => openWhatsApp('Olá! Quero falar com vendas sobre o plano Enterprise de mensageria.')}
              >
                Falar com Vendas
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Depoimentos */}
      <section className="depoimentos-section-msg reveal">
        <div className="container-mensageria">
          <div className="section-header-msg">
            <h2>O que nossos clientes dizem</h2>
            <p>Histórias reais de empresas que transformaram sua gestão com AtendeChat</p>
          </div>

          <div className="depoimentos-grid-msg">
            <div className="depoimento-card-msg">
              <p className="depoimento-texto">
                "AtendeChat revolucionou a forma como gerenciamos nossos projetos. 
                A produtividade da equipe aumentou em 40% desde que começamos a usar."
              </p>
              <div className="depoimento-autor">
                <div className="autor-avatar-msg"></div>
                <div>
                  <strong>Maria Silva</strong>
                  <span>CEO, TechStart</span>
                </div>
              </div>
            </div>

            <div className="depoimento-card-msg">
              <p className="depoimento-texto">
                "A facilidade de uso e as features de colaboração em tempo real 
                fazem toda a diferença no nosso dia a dia."
              </p>
              <div className="depoimento-autor">
                <div className="autor-avatar-msg"></div>
                <div>
                  <strong>João Santos</strong>
                  <span>CTO, InnovaTech</span>
                </div>
              </div>
            </div>

            <div className="depoimento-card-msg">
              <p className="depoimento-texto">
                "Os relatórios e análises nos ajudam a tomar decisões melhores 
                e mais rápidas. Excelente ferramenta!"
              </p>
              <div className="depoimento-autor">
                <div className="autor-avatar-msg"></div>
                <div>
                  <strong>Ana Costa</strong>
                  <span>PM, GrowthCorp</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="cta-final-mensageria reveal reveal--scale">
        <div className="container-mensageria">
          <div className="cta-content-msg">
            <h2>Simplifique seu atendimento e venda mais com nosso chatbot para WhatsApp!</h2>
            <p>Junte-se a diversas empresas que já transformaram seu atendimento e aumentaram suas vendas com o AtendeChat!</p>
            <button
              className="btn-cta-white-msg"
              onClick={() => openWhatsApp('Olá! Quero conhecer a solução de chatbot e multiatendimento da UpdateCommit.')}
            >
              Começar Agora
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Mensageria;
